import { Grid } from '@mui/material';
import { Input } from '../Input';
import { useAppDispatch, useAppSelector } from '../../redux/hooks';
import { RootState } from '../../redux/store';
import { REDUX_KEY } from '../../redux/constants';
import { updateField } from '../../redux/features/campaignDetail/campaignDetailSlice';
import { isOnlyNumbers } from '../../util';
import { useState } from 'react';

const CampaignDetails = () => {
  const dispatch = useAppDispatch();
  const { agencyName, advertiserDiscount, advertiserName, campaignName } =
    useAppSelector((state: RootState) => state.detail);
  const [discount, setDiscount] = useState('0');

  const handleChange = (fieldName: string, value: string | number) => {
    const updatedField = updateField({
      fieldName,
      value
    });

    dispatch(updatedField);
  };

  const handleDiscountUpdate = (value: string) => {
    if (!isOnlyNumbers(value)) {
      return;
    }

    setDiscount(value);
    handleChange(REDUX_KEY.ADVERTISER_DISCOUNT, Number(value) / 100);
  };

  return (
    <>
      <Grid container rowSpacing={1} columnSpacing={{ xs: 1 }}>
        <Grid item xs={6}>
          <Input
            label="Agency Name"
            onChange={(value: string) =>
              handleChange(REDUX_KEY.AGENCY_NAME, value)
            }
            value={agencyName}
            error={agencyName === ' '}
            required
          />
        </Grid>
        <Grid item xs={6}>
          <Input
            label="Advertiser Discount"
            helperText="Percentage (%)"
            onChange={(value: string) => handleDiscountUpdate(value)}
            value={discount === '0' ? '' : discount}
            error={isNaN(advertiserDiscount) || advertiserDiscount > 1}
          />
        </Grid>
        <Grid item xs={6}>
          <Input
            label="Advertiser Name"
            onChange={(value: string) =>
              handleChange(REDUX_KEY.ADVERTISER_NAME, value)
            }
            value={advertiserName}
            error={advertiserName === ' '}
            required
          />
        </Grid>
        <Grid item xs={6}>
          <Input
            label="Campaign Name"
            onChange={(value: string) =>
              handleChange(REDUX_KEY.CAMPAIGN_NAME, value)
            }
            value={campaignName}
            error={campaignName === ' '}
            required
          />
        </Grid>
      </Grid>
    </>
  );
};

export default CampaignDetails;
